/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@sainsburys-tech/bolt';
import ContentPlaceholder from '../ContentPlaceholder/ContentPlaceholder';
import AvailabilityResult from '../AvailabilityResult/AvailabilityResult';
import * as Styled from './MoreAvailability.styles';
var PROP_TYPES = {
  availability: PropTypes.array,
  loading: PropTypes.bool,
  error: PropTypes.bool,
  fetchMoreAvailability: PropTypes.func,
  moreAvailabilityHeading: PropTypes.string,
  toggleActiveStore: PropTypes.func,
  selectStoreCallback: PropTypes.func,
  ctaAddToTrolley: PropTypes.func,
  searchTerm: PropTypes.string,
  showExpand: PropTypes.bool
};
var DEFAULT_PROPS = {
  availability: null
};

var MoreAvailability = function MoreAvailability(_ref) {
  var availability = _ref.availability,
      loading = _ref.loading,
      error = _ref.error,
      fetchMoreAvailability = _ref.fetchMoreAvailability,
      moreAvailabilityHeading = _ref.moreAvailabilityHeading,
      toggleActiveStore = _ref.toggleActiveStore,
      selectStoreCallback = _ref.selectStoreCallback,
      ctaAddToTrolley = _ref.ctaAddToTrolley,
      searchTerm = _ref.searchTerm,
      showExpand = _ref.showExpand;
  return /*#__PURE__*/React.createElement(Styled.MoreAvailabilityContainer, null, loading && /*#__PURE__*/React.createElement(Styled.MoreAvailabilitySection, null, /*#__PURE__*/React.createElement(ContentPlaceholder, null)), !loading && !error && availability === null && /*#__PURE__*/React.createElement(Styled.MoreAvailabilityFeaturePanel, null, /*#__PURE__*/React.createElement(Styled.MoreAvailabilityTitle, null, "Happy to travel?"), /*#__PURE__*/React.createElement(Styled.MoreAvailabilityText, null, "There are no stores in your immediate area where you can get this item."), /*#__PURE__*/React.createElement(Styled.MoreAvailabilityText, null, "You may need to travel to a store further away. But if you need it, you need it..."), /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick(event) {
      return fetchMoreAvailability(event);
    },
    "data-test": "fetch more availability"
  }, "Tell me where")), !loading && !error && availability && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Styled.MoreAvailabilityHeader, null, moreAvailabilityHeading), availability.map(function (store, index) {
    return /*#__PURE__*/React.createElement(AvailabilityResult, {
      key: index,
      store: store.storeInfo,
      storeDistance: store.storeDistance,
      showExpand: showExpand,
      availability: store.availability,
      products: store.products,
      selectStoreCallback: selectStoreCallback,
      ctaAddToTrolley: ctaAddToTrolley,
      searchTerm: searchTerm,
      toggleActiveStore: toggleActiveStore,
      isMoreAvailabilityResult: true
    });
  })), !availability && !loading && error && /*#__PURE__*/React.createElement(Styled.MoreAvailabilityFeaturePanel, null, /*#__PURE__*/React.createElement(Styled.MoreAvailabilityTitle, null, "Sorry"), /*#__PURE__*/React.createElement(Styled.MoreAvailabilityText, null, "Collection is not available in any of our stores.")));
};

MoreAvailability.propTypes = PROP_TYPES;
MoreAvailability.defaultProps = DEFAULT_PROPS;
export default MoreAvailability;